import ReactCountryFlag from "react-country-flag";
import RefreshButton from "./RefreshButton";
import { isoCountries, timeConverter } from "./TableHelper";
import { MdCheck } from "react-icons/md";

export const COLUMNS = [
  {
    Header: "ID",
    accessor: "id",
    disableFilters: true,
  },
  {
    Header: "Tier",
    accessor: "tier",
    Cell: ({ value }) => {
      if (value === "complementary") return "---";
      else return value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
    },
    disableFilters: true,
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Status",
    accessor: "status",
    disableFilters: true,
  },
  {
    Header: "Country",
    accessor: "country",
    Cell: ({ value }) => {
      return (
        <>
          <ReactCountryFlag className="country-flag" countryCode={value} aria-label={`${value}_flag`} svg />
          <span className="country-name">{isoCountries[value]}</span>
        </>
      );
    },
    disableFilters: true,
  },
  {
    Header: "Subscriber since",
    accessor: "activeSince",
    Cell: ({ value }) => {
      return timeConverter(value);
    },
    disableFilters: true,
  },
  {
    Header: "Newsletter",
    accessor: "newsletter",
    Cell: ({ value }) => {
      return <div className="newsletter-icon-container">{value && <MdCheck fill="#30b451" />}</div>;
    },
    // disableFilters: true,
  },
  {
    Header: "Refresh",
    Footer: "Refresh",
    accessor: "refreshId",
    Cell: ({ value, setUserData, userData, index }) => {
      return (
        <div className="refresh-button-container">
          <RefreshButton id={value} setUserData={setUserData} userData={userData} index={index} />
        </div>
      );
    },
    disableFilters: true,
  },
];
